function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip-path"
}, React.createElement("rect", {
  id: "Rectangle_81195",
  "data-name": "Rectangle 81195",
  width: 30.369,
  height: 22.902,
  transform: "translate(0 0)"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_18213",
  "data-name": "Group 18213",
  clipPath: "url(#clip-path)"
}, React.createElement("path", {
  id: "Path_22442",
  "data-name": "Path 22442",
  d: "M10.067,0a6.04,6.04,0,1,0,6.04,6.04A6.04,6.04,0,0,0,10.067,0"
}), React.createElement("path", {
  id: "Path_22443",
  "data-name": "Path 22443",
  d: "M17.582,16.021a8.613,8.613,0,0,0-6.173-2.6H8.725a8.611,8.611,0,0,0-6.173,2.6A8.8,8.8,0,0,0,0,22.227a.674.674,0,0,0,.671.675H19.462a.675.675,0,0,0,.672-.675,8.8,8.8,0,0,0-2.552-6.206"
}), React.createElement("path", {
  id: "Path_22444",
  "data-name": "Path 22444",
  d: "M29.065,8.943H27.858l0,0H26.266V6.127a1.271,1.271,0,0,0-.405-.89,1.3,1.3,0,0,0-.916-.342,1.288,1.288,0,0,0-1.232,1.248v2.8H20.928a1.278,1.278,0,1,0-.016,2.554h2.8v2.818a1.281,1.281,0,0,0,1.279,1.231h.044a1.286,1.286,0,0,0,1.23-1.249V11.5h2.782a1.311,1.311,0,0,0,.916-.342,1.27,1.27,0,0,0,.407-.889,1.294,1.294,0,0,0-1.3-1.323"
}));

var SvgAssignTo = function SvgAssignTo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Group_18214",
    "data-name": "Group 18214",
    width: 30.369,
    height: 22.902,
    viewBox: "0 0 30.369 22.902",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAssignTo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/AssignTo.fa617e4b.svg";
export { ForwardRef as ReactComponent };